/// <amd-module name="Test/TestSummary/Actions/TestResultsReportActionsHub" />
import { Action } from "VSS/Reflux/Action";
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { ViewContextStatus } from "Test/common-util/Common";
import { ITestResultViewContextPayload } from "Test/common-util/Contracts/ViewContracts";

export class TestResultsReportActionsHub {
	public initializeTestResultSummary = new Action<ISummaryInitializationData>();
	public initializeTestResultSummaryForUnifiedPipeline = new Action<ISummaryInitializationDataForUnifiedPipeline>();
	public refreshTestResultSummary = new Action<void>();
	public onSummaryLoaded = new Action<ITestResultViewContextPayload>();
}

export interface ISummaryInitializationData {
	summaryData: TCMContracts.TestResultSummary;
	viewContextStatus: ViewContextStatus | undefined;
}

export interface ISummaryInitializationDataForUnifiedPipeline {
	summaryData: TCMContracts.PipelineTestMetrics;
	viewContextStatus: ViewContextStatus | undefined;
}
